import { LogLevel } from '@/config/loggingConfig';

export type LogMeta = Record<string, unknown>;

export interface LogPayload {
    level: LogLevel;
    message: string;
    meta?: LogMeta;
}

const sendLog = (level: LogLevel, message: string, meta: LogMeta = {}): void => {
    fetch('/api/logs', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ level, message, meta }),
    }).catch((err: unknown) => {
        console.error('Error sending log to the server:', err);
    });
};

export const clientLogger = {
    log: (message: string, meta?: LogMeta) => sendLog(LogLevel.INFO, message, meta),
    info: (message: string, meta?: LogMeta) => sendLog(LogLevel.INFO, message, meta),
    warn: (message: string, meta?: LogMeta) => sendLog(LogLevel.WARN, message, meta),
    error: (message: string, meta?: LogMeta) => sendLog(LogLevel.ERROR, message, meta),
    debug: (message: string, meta?: LogMeta) => sendLog(LogLevel.DEBUG, message, meta),
};
